import { useEffect, useState } from "react";
import moment from "moment";
import Loader from "../../../../components/designs/loader";
import axiosService from "../../../../core/services/axios-service";
import { ApiRoutes } from "../../../../core/dictionary/api-url";
import { organizationPlanEnum } from "../../../../core/dictionary/global-enums";

export default function ViewOrganization({ organizationId }) {
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!organizationId) return;
    setLoading(true);
    axiosService
      .get(`${ApiRoutes.ORGANIZATION_DETAILS}/${organizationId}`)
      .then((res) => {
        if (res.data && res.data.success && res.data.data) {
          setOrg(res.data.data);
        } else {
          setError("Organization not found.");
        }
      })
      .catch(() => setError("Server error. Please try again."))
      .finally(() => setLoading(false));
  }, [organizationId]);

  if (loading) return <Loader text="Loading organization details..." />;
  if (error) return <div className="text-danger p-3">{error}</div>;
  if (!org) return null;

  return (
    <div className="card p-4">
      <h4 className="mb-3">{org.organizationName}</h4>
      <div className="mb-2">
        <strong>Address:</strong> {org.organizationAddress}
      </div>
      <div className="mb-2">
        <strong>Contact Number:</strong> {org.organizationContactNumber}
      </div>
      <div className="mb-2">
        <strong>Email:</strong> {org.organizationEmail}
      </div>
      <div className="mb-2">
        <strong>Type:</strong> {org.organizationType}
      </div>
      <div className="mb-2">
        <strong>Selected Plan :</strong> {organizationPlanEnum[org.organizationPlan]}
      </div>
      <div className="mb-2">
        <strong>Number of Seats:</strong> {org.organizationCoachseats}
      </div>
      <div className="mb-2">
        <strong>Created By:</strong> {org.createdBy?.email}
      </div>
      <div className="mb-2">
        <strong>Created At:</strong>{" "}
        {moment(org.createdAt).format("Do MMM YYYY, h:mm A")}
      </div>
      <div className="mb-2">
        <strong>Last Updated At:</strong>{" "}
        {moment(org.updatedAt).format("Do MMM YYYY, h:mm A")}
      </div>
    </div>
  );
}